import React, { Fragment, useReducer, useEffect, useState } from "react";
import { Button, Dropdown, Modal, Tab, Nav } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
// import styles
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import PageTitle from "../../../layouts/PageTitle";
import profile from "../../../../images/profile/profile.jpg";
import { resetPasswordAction } from "../../../../store/actions/auth/AuthActions";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";

const AppProfile = () => {
  const [userDetails, setUserDetails] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    let data = JSON.parse(localStorage.getItem("userDetails"));
    setUserDetails(data);
  }, []);

  const validationSchema = Yup.object().shape({
    current_password: Yup.string().required("Current password is required"),
    new_password: Yup.string().required("New password is required").min(6, "Password must be at least 6 characters long"),
  });

  const options = {
    settings: {
      overlayColor: "#000000",
    },
  };
  // const submitForm = (e) => {
  //   e.preventDefault();
  //   const { email } = e.target;
  //   let payload = {
  //     current_password: "password",
  //     new_password: "password",
  //   };
  //   dispatch(resetPasswordAction(payload, navigate));
  // };

  const handlePasswordReset = (values, { setSubmitting }) => {
    // debugger;
    const { current_password, new_password } = values;
    const payload = {
      current_password,
      new_password,
    };
    //debugger;
    dispatch(resetPasswordAction(payload, navigate));
    setSubmitting(false);
  };

  return (
    <Fragment>
      <PageTitle activeMenu='Profile' motherMenu='App' />
      <div className='row'>
        <div className='col-lg-12'>
          <div className='profile card card-body px-3 pt-3 pb-0'>
            <div className='profile-head'>
              <div className='photo-content '>
                <div className='cover-photo rounded'></div>
              </div>
              <div className='profile-info'>
                <div className='profile-photo'>
                  <img src={profile} className='img-fluid rounded-circle' alt='profile' />
                </div>
                <div className='profile-details'>
                  <div className='profile-name px-3 pt-2'>
                    <h4 className='text-primary mb-0'>DhanGold App</h4>
                    <p>{userDetails.role_name}</p>
                  </div>
                  <div className='profile-email px-2 pt-2'>
                    <h4 className='text-muted mb-0'>{userDetails.email}</h4>
                    <p>Email</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-xl-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='profile-tab'>
                <div className='custom-tab-1'>
                  <Tab.Container defaultActiveKey='AccountDetails'>
                    <Nav as='ul' className='nav nav-tabs'>
                      <Nav.Item as='li' className='nav-item'>
                        <Nav.Link to='#profile-settings' eventKey='AccountDetails'>
                          Account Details
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item as='li' className='nav-item'>
                        <Nav.Link to='#profile-settings' eventKey='Setting'>
                          Setting
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content>
                      <Tab.Pane id='profile-settings' eventKey='AccountDetails'>
                        <div className='pt-3'>
                          <div className='row'>
                            <div className='col-lg-12'>
                              <div className='card'>
                                <div className='card-body'>
                                  <div className='table-responsive'>
                                    <table className='table table-bordered'>
                                      <tbody>
                                        <tr>
                                          <td>Display Name</td>
                                          <td>{userDetails.display_name ? userDetails.display_name : "-"}</td>
                                        </tr>
                                        <tr>
                                          <td>Employee Id</td>
                                          <td>{userDetails.emp_id ? userDetails.emp_id : "-"}</td>
                                        </tr>
                                        <tr>
                                          <td>Email</td>
                                          <td>{userDetails.email ? userDetails.email : "-"}</td>
                                        </tr>
                                        <tr>
                                          <td>Id</td>
                                          <td>{userDetails.id ? userDetails.id : "-"}</td>
                                        </tr>
                                        <tr>
                                          <td>Role Name</td>
                                          <td>{userDetails.role_name ? userDetails.role_name : "-"} </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane id='profile-settings' eventKey='Setting'>
                        <div className='pt-3'>
                          <div className='settings-form'>
                            <h4 className='text-primary'>Reset Password</h4>
                            {/* <form onSubmit={(e) => e.preventDefault()}>
                              <div className='row'>
                                <div className='form-group mb-3 col-md-4'>
                                  <label className='form-label'>Current Password</label>
                                  <input type='password' name='current_password' placeholder='Current Password' className='form-control' />
                                </div>
                                <div className='form-group mb-3 col-md-4'>
                                  <label className='form-label'>New Password</label>
                                  <input type='password' name='new_password' placeholder='New Password' className='form-control' />
                                </div>
                              </div>

                              <button className='btn btn-primary' type='submit'>
                                Update
                              </button>
                            </form> */}
                            <Formik initialValues={{ current_password: "", new_password: "" }} validationSchema={validationSchema} onSubmit={handlePasswordReset}>
                              {({ isSubmitting }) => (
                                <Form>
                                  <div className='row'>
                                    <div className='form-group mb-3 col-md-4'>
                                      <label className='form-label'>Current Password</label>
                                      <Field type='password' name='current_password' placeholder='Current Password' className='form-control' />
                                      <ErrorMessage name='current_password' component='div' className='text-danger' />
                                    </div>
                                    <div className='form-group mb-3 col-md-4'>
                                      <label className='form-label'>New Password</label>
                                      <Field type='password' name='new_password' placeholder='New Password' className='form-control' />
                                      <ErrorMessage name='new_password' component='div' className='text-danger' />
                                    </div>
                                  </div>
                                  <button className='btn btn-primary' type='submit' disabled={isSubmitting}>
                                    {isSubmitting ? "Updating..." : "Update"}
                                  </button>
                                </Form>
                              )}
                            </Formik>
                          </div>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AppProfile;
